<template>
  <div class="">
    <div>
      <a-table
        :columns="columns"
        :data-source="displayStockProducts"
        :loading="tableLoading"
        :pagination="pagination"
        class="tableStyle"
      >
      </a-table>
    </div>
  </div>
</template>

<script>
// import moment from "moment";
export default {
  name: "StockCountProducts",
  props: {
    counts: {
      type: Object,
      default: function () {
        return { };
      },
    },
  },
  data: () => ({
    tableLoading: false,
    selectedCount: {},
    pagination: {
      pageSize: 20,
    },
    columns: [
      {
        title: "ID",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "Product ID",
        dataIndex: "productId",
        key: "productId",
      },
      {
        title: "Product Name",
        dataIndex: "productBrandName",
        key: "productBrandName",
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
      },
      {
        title: "Expected Quantity",
        dataIndex: "expectedQuantity",
        key: "expectedQuantity",
      },
      {
        title: "Quantity Difference",
        dataIndex: "difference",
        key: "difference",
      },
      {
        title: "Comment",
        dataIndex: "comment",
        key: "comment",
      },
    ],
    displayStockProducts: [],
    showUpdateModal: false
  }),
  watch: {
    counts: function(newStocks) { this.setTableData(newStocks.inventoryCountLines)}
  },
  methods: {
     setTableData(newStocks) {
      // console.log('new stocks', newStocks);
      this.displayStockProducts = [...newStocks];
      this.displayStockCounts.forEach((stock) => { 
        stock.comment = stock.comment | 'N/A'
        stock.key = stock.id + stock.productId;
      })
    },
  },
  mounted() {
    this.setTableData(this.counts.inventoryCountLines)
  }
};
</script>

<style scoped>
.requestActions{
    display: flex;
    justify-content:flex-end;
    margin-bottom: 20px;
}

.card-container {
  background: none;
  overflow: hidden;
  /* padding: 24px; */
}
.card-container > .ant-tabs-card > .ant-tabs-content {
  height: 120px;
  margin-top: -16px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;

}

.card-container >>> .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    height: 40px;
    color: #98c14b;
    background: #e5efe7;
    border-color: #e5efe7;
    border-bottom: 1px solid #98c14b;
}
.card-container >>> .ant-tabs-tab {
    height: 40px;
    margin: 0;
    width: 217px;
    margin-right: 2px;
    padding: 0 16px;
    line-height: 38px;
    background: #fafafa;
    border: 1px solid #e8e8e8;

}
.card-container >>> .ant-tabs-tab:hover {
    color: #98c14b;
    /* background: #e5efe7; */
}

.modalStyle >>> .ant-modal-header {
    border-bottom: none;
}

.modalStyle >>> .ant-modal-footer {
    border-top: none;
}
.modalStyle{
    display: flex;
    justify-content: center;
}

.card-container >>> .ant-badge-count {
    z-index: auto;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    color: #fff;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
    text-align: center;
    background: #98c14b;
    border-radius: 10px;
    box-shadow: 0 0 0 1px #fff;
}

 .spinner >>> .ant-spin-dot-item {
    background-color: #418a49;
}

.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #e5efe7;
  background: #e5efe7;
}

.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}

button:hover{
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}
.tableStyle >>> .ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle >>> .ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle >>> .ant-pagination-item-active a {
    color: #fff;
}
.tableStyle >>> .ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-thead th {
  background: #c7c7c763;
  height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
  background: #418a49;
  border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
  color: #fff;
}

.tableStyle>>>.ant-table-pagination {
  float: none;
  margin: 16px 0;
  display: flex;
  justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
  background: #26A246;
  color: #fff;

}

.tableStyle>>>.ant-table-thead th {
  background: #fff;
  height: 63px;
}

.tableStyle>>>.ant-table-header {
  background: #fff !important;
}
</style>